import React from "react";

import {
  Card,
  CardBody,
  Content
} from "@patternfly/react-core";

const EducationDashboardHeader = () => {
  return (
    // <Card isCompact>
    //   <CardBody>
    //     <Content component="h2">
    //       Platforma edukacyjna
    //     </Content>

    //     <Content component="p">
    //       Twoje środowisko pracy, materiały edukacyjne
    //       i przygotowanie do egzaminów zawodowych.
    //     </Content>
    //   </CardBody>
    // </Card>
    <Content>
      <Content component="h1">
        Platforma edukacyjna
      </Content>

      <Content component="p">
        Twoje środowisko pracy i postęp przygotowania
        do egzaminów zawodowych.
      </Content>
    </Content>
  );
};

export default EducationDashboardHeader;